const hideFullPageLoader = () => document.querySelectorAll('.full-page-loader')
		.forEach(loader => loader.remove());

export {hideFullPageLoader};